// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__R-X-3","noInteraction":"EventWrapper_noInteraction__1ixvr"};